import { Input } from '@beamery/lib-ds-components';
import styled from 'styled-components';

export const FormInput = styled(Input)`
  & input {
    height: 100%;
  }
`;
